export enum DatabaseName {
  Wedding = 'Database0',
}

export enum DbCollections {
  Households = 'houseHolds',
  Shifts = 'shifts',
  Locations = 'locations'
}
